import React from "react";
import "./Pages.css";

const PrivacyPolicy: React.FC = () => {
  return (
    <div className="page-container">
      <h1>Privacy Policy</h1>
      <p>
        At Destination Dreams Travel, your privacy is important. We collect only the necessary personal data for booking flights, hotels, and packages. Your information will never be shared with third parties without consent.
      </p>
      <h2>Information Collection</h2>
      <ul>
        <li>Name, email, phone number</li>
        <li>Booking preferences and travel history</li>
        <li>Payment and billing details</li>
      </ul>
      <h2>Use of Information</h2>
      <p>
        We use your information to provide services, send updates and promotional offers, and improve our website experience.
      </p>
    </div>
  );
};

export default PrivacyPolicy;
